import React from "react";

export default ({ close, onCloseClick }) => (
  <button className={close} onClick={onCloseClick} aria-label="closeButton">
    <svg
      width="7"
      height="7"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginBottom: "1px" }}
    >
      <path
        d="M17 1.68182L1 17.6818"
        stroke="#818181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1.68182L17 17.6818"
        stroke="#818181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);
